import { createSlice } from '@reduxjs/toolkit';
import { ServiceFocusesState } from './service-focus.state';
import { FetchServiceFocuses } from './thunks/fetch-service-focuses.thunk';
import { AddServiceFocus } from './thunks/add-service-focus.thunk';
import { UpdateServiceFocus } from './thunks/update-service-focus.thunk';
import { DeleteServiceFocus } from './thunks/delete-service-focus.thunk';
import { moveRootOtherFocusToEnd } from '../../containers/UserPages/Login/Modals/PracticeRegistrationForm/utils';

const initialState: ServiceFocusesState = {
    serviceFocuses: [],
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const serviceFocusesSlice = createSlice({
    name: 'serviceFocuses',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(FetchServiceFocuses.pending, (state) =>
                setPendingState(state)
            )
            .addCase(FetchServiceFocuses.rejected, (state, action) =>
                setRejectedState(
                    state,
                    action.error.message || 'Failed to fetch service focuses'
                )
            )
            .addCase(FetchServiceFocuses.fulfilled, (state, action) => {
                state.serviceFocuses = moveRootOtherFocusToEnd(action.payload);
                setSucceededState(state);
            })

            .addCase(AddServiceFocus.pending, (state) => setPendingState(state))
            .addCase(AddServiceFocus.rejected, (state, action) =>
                setRejectedState(
                    state,
                    action.error.message || 'Failed to add service focus'
                )
            )
            .addCase(AddServiceFocus.fulfilled, (state, action) => {
                state.serviceFocuses.push(action.payload);
                state.serviceFocuses = moveRootOtherFocusToEnd(state.serviceFocuses);
                setSucceededState(state);
            })

            .addCase(UpdateServiceFocus.pending, (state) =>
                setPendingState(state)
            )
            .addCase(UpdateServiceFocus.rejected, (state, action) =>
                setRejectedState(
                    state,
                    action.error.message || 'Failed to update service focus'
                )
            )
            .addCase(UpdateServiceFocus.fulfilled, (state, action) => {
                const index = state.serviceFocuses.findIndex(
                    (f) => f.id === action.payload.id
                );
                if (index !== -1) {
                    state.serviceFocuses[index] = action.payload;
                }
                setSucceededState(state);
            })

            .addCase(DeleteServiceFocus.pending, (state) =>
                setPendingState(state)
            )
            .addCase(DeleteServiceFocus.rejected, (state, action) =>
                setRejectedState(
                    state,
                    action.error.message || 'Failed to delete service focus'
                )
            )
            .addCase(DeleteServiceFocus.fulfilled, (state, action) => {
                state.serviceFocuses = state.serviceFocuses.filter(
                    (f) => f.id !== action.payload
                );
                setSucceededState(state);
            });
    },
});

const setRejectedState = (state: ServiceFocusesState, errorMessage: string) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = errorMessage;
};

const setPendingState = (state: ServiceFocusesState) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: ServiceFocusesState) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = serviceFocusesSlice.actions;
export default serviceFocusesSlice.reducer;
